import React from 'react'
import { AuthContextProvider } from './Auth'
import { NotificacoesContextProvider } from './Notificacoes'

type Props = {
    children: React.ReactNode
}

export const ContextProviders: React.FC<Props> = ({ children }) => {
    return (
        <AuthContextProvider>
            <NotificacoesContextProvider>
                {children}
            </NotificacoesContextProvider>
        </AuthContextProvider>
    )
}
